// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"672":"69859c62","825":"d33b5940","830":"bf027079","854":"2c75f3af","922":"d9325ca4"}[chunkId] + ".js";
};